import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { EditAddressForm } from './edit-address-form';
import type { EditAddressFormData } from './schema';
import type { Address } from '@/hooks/queries/use-get-user-detail.query';

interface EditAddressFormDialogProps {
  onSuccess?: (data: EditAddressFormData) => void;
  open?: boolean;
  onToggle?: () => void;
  onClose?: () => void;
  address: Address;
}

export function EditAddressFormDialog({
  onSuccess,
  open,
  onToggle,
  onClose,
  address,
}: EditAddressFormDialogProps) {
  const handleSuccess = (data: EditAddressFormData) => {
    onSuccess?.(data);
    onClose?.();
  };

  return (
    <Dialog open={open} onOpenChange={onToggle}>
      <DialogContent className="max-w-[calc(100%-2rem)] sm:max-w-xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="mb-4">Edit Address</DialogTitle>
        </DialogHeader>
        <EditAddressForm address={address} onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
}

export { type EditAddressFormData } from './schema';
